// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"9f075486","401":"cd2e7fdf"}[chunkId] + ".chunk.js";
};